import '.b4{position:relative;}.ssr-plugin'
import '.jg{width:64px;}.ssr-plugin'
import '.jh{height:64px;}.ssr-plugin'
import '.ah{flex-shrink:0;}.ssr-plugin'
import '.bq{position:absolute;}.ssr-plugin'
import '.ji{bottom:-4px;}.ssr-plugin'
import '.i7{right:-4px;}.ssr-plugin'
import '.fy{border-radius:50%;}.ssr-plugin'
import '.d2{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ar{overflow:hidden;}.ssr-plugin'
import '.jj{width:32px;}.ssr-plugin'
import '.jk{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="b4 jg jh ah"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bq ji i7 fy d2 ar jj jk"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
